import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Common.css';

const Privacy = ({ onNavigate }) => {
  const handleContactClick = () => {
    if (onNavigate) {
      onNavigate('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="privacy-page">
      {/* Header Section */}
      <section className="contact-header-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="contact-main-title">Privacy Policy</h1>
              {/* <p className="contact-subtitle">
                Your privacy is important to us. This policy explains how we collect,
                use, and protect your personal information.
              </p> */}
              <p className="privacy-date">Last updated on 25-NOV-2024</p>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="privacy-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-12">
              {/* Introduction */}
              <div className="privacy-intro mb-5">
                <p className="privacy-text">
                  At Orthomed, we value your trust and are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you interact with our website, products, and services.
                </p>
              </div>

              {/* Section 1 */}
              <div className="privacy-section mb-5">
                <h2 className="section-heading">1. Information We Collect</h2>
                <p className="privacy-text mb-3">
                  We may collect the following types of information:
                </p>
                <ul className="privacy-list">
                  <li><strong>Personal Information:</strong> Name, email address, phone number, billing and shipping addresses, and other details you provide during account registration or purchases.</li>
                  <li><strong>Non-Personal Information:</strong> Browser type, IP address, device information, and browsing behavior through cookies or similar technologies.</li>
                </ul>
              </div>

              {/* Section 2 */}
              <div className="privacy-section mb-5">
                <h2 className="section-heading">2. How We Use Your Information</h2>
                <p className="privacy-text mb-3">
                  We use the collected information to:
                </p>
                <ul className="privacy-list">
                  <li>Fulfill orders and provide customer support.</li>
                  <li>Improve our website, products, and services.</li>
                  <li>Send promotional offers, updates, or newsletters (only if you opt-in).</li>
                  <li>Comply with legal obligations and secure transactions.</li>
                </ul>
              </div>

              {/* Section 3 */}
              <div className="privacy-section mb-5">
                <h2 className="section-heading">3. Sharing of Information</h2>
                <p className="privacy-text mb-3">
                  We do not sell or rent your personal information to third parties. However, we may share your information with:
                </p>
                <ul className="privacy-list">
                  <li><strong>Service Providers:</strong> Partners who assist with payment processing, shipping, or analytics.</li>
                  <li><strong>Legal Authorities:</strong> When required to comply with laws or enforce our policies.</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div className="privacy-section mb-5">
                <h2 className="section-heading">4. Cookies and Tracking Technologies</h2>
                <p className="privacy-text">
                  We use cookies to enhance your browsing experience. These cookies help us analyze website traffic and personalize content. You can disable cookies in your browser settings, but certain functionalities may be affected.
                </p>
              </div>

              {/* Section 5 */}
              <div className="privacy-section mb-5">
                <h2 className="section-heading">5. Data Security</h2>
                <p className="privacy-text">
                  We implement robust security measures to protect your information. Despite our efforts, no method of data transmission or storage is 100% secure.
                </p>
              </div>

              {/* Section 6 */}
              <div className="privacy-section mb-5">
                <h2 className="section-heading">6. Third-Party Links</h2>
                <p className="privacy-text">
                  Our website may include links to external websites. We are not responsible for the privacy practices of these third-party sites.
                </p>
              </div>

              {/* Section 7 */}
              <div className="privacy-section mb-5">
                <h2 className="section-heading">7. SMS Communications</h2>
                <p className="privacy-text mb-3">
                  We comply with privacy requirements related to SMS communications:</p>

                <h3 className="subsection-heading">Consent for SMS Communication</h3>
                <p className="privacy-text mb-3">
                  Information obtained as part of the SMS consent process will not be shared with third parties.
                </p>

                <h3 className="subsection-heading">Types of SMS Communications</h3>
                <p className="privacy-text mb-3">
                  If you have consented to receive text messages from Orthomed, you may receive messages related to:
                </p>

                <ul className="privacy-list mb-3">
                  <li><strong>Customers and Guests:</strong> Updates regarding your orders, deliveries, or other relevant information.</li>
                  <li><strong>Job Applicants:</strong> Information about your application status, onboarding materials, or other employment-related updates.</li>
                </ul>

                <h3 className="subsection-heading">Standard Messaging Disclosures</h3>
                <ul className="privacy-list">
                  <li>Message and data rates may apply.</li>
                  <li>You can opt-out at any time by texting “STOP.”</li>
                  <li>For questions text "HELP" or you can visit our privacy policy .</li>
                </ul>
              </div>

              {/* Section 8 */}
              <div className="privacy-section mb-5">
                <h2 className="section-heading">8. Changes to This Policy</h2>
                <p className="privacy-text">
                  We may update this Privacy Policy periodically. Any changes will be posted on this page with an updated effective date.
                </p>
              </div>

              {/* Section 9 */}
              <div className="privacy-section mb-5">
                <h2 className="section-heading">9. Contact Us</h2>

                <p className="privacy-text mb-3">
                  If you have questions or concerns about this Privacy Policy, please contact us:
                </p>

                <div className="contact-info">
                  <p className="contact-detail">
                    <strong>Email:</strong>{" "}
                    <a
                      href="mailto:orthomedproducts@gmail.com"
                      className="contact-link"
                    >
                      orthomedproducts@gmail.com
                    </a>
                  </p>

                  <p className="contact-detail">
                    <strong>Phone:</strong>{" "}
                    <a
                      href="tel:+17326518800"
                      className="contact-link"
                    >
                      732 651 8800
                    </a>
                  </p>

                  <p className="contact-detail">
                    <strong>Address:</strong> 11 Elkins Rd, East Brunswick, NJ 08816
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-3 mb-lg-0">
                <h3 className="cta-title">Contact us today to learn more about our products.</h3>
              </div>
              <div className="col-lg-4 text-lg-end">
                <button className="btn-cta" onClick={handleContactClick}>
                  Contact Us Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;